export const CUSTOMER_ADDRESS_LABEL = 'Your address'

export const CUSTOMER_ADDRESS_REQUIRED_ERROR = 'Please enter your address.'

/** What the privacy notice says we collect; the address only for a customer-address type. */
export const COLLECTED_DETAILS = 'name, phone number and email address'
export const COLLECTED_DETAILS_WITH_ADDRESS = 'name, address, phone number and email address'

export const QUESTION_REQUIRED_ERROR = 'This question is required.'

export const QUESTION_PICK_OPTION_ERROR = 'Please pick an option.'

export const SELECT_ONE_LABEL = 'Select one'

/** A short answer shows its counter only from this share of the cap; a long answer always does. */
export const SHORT_TEXT_COUNTER_FROM = 0.8
